import { state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { IconComponent } from '../../../osp-ui/components/icon/icon/icon.component';
import { ToastComponent } from '../../../osp-ui/components/messages/toast/toast.component';
import { Message } from '../../../osp-ui/contract/message.contract';
import { FormatDateTimePipe } from '../../pipes/format-date-time.pipe';
import { IconPipe } from '../../pipes/icon.pipe';

@Component({
  selector: 'osp-root-toast',
  standalone: true,
  imports: [ToastComponent, IconComponent, TranslateModule, CommonModule, IconPipe, FormatDateTimePipe],
  templateUrl: './root-toast.component.html',
  styleUrl: './root-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('shrinkAnimation', [
      state(
        'void',
        style({
          width: '100%',
        }),
      ),
      state(
        '*',
        style({
          width: '0%',
        }),
      ),
      transition('void => *', []),
    ]),
  ],
})
export class RootToastComponent {
  protected key$ = new Subject<string>();

  @ViewChild('toast') toast!: ToastComponent;

  readonly IconKey = IconKey;

  protected dismiss(message: Message): void {
    const index = (this.toast.messages ?? []).findIndex(({ id }) => id === message.id);
    this.toast.messages?.splice(index, 1);
  }
}
